import { DropdownOption, RelativeDate } from 'leanplum-lib-common';
import values from 'lodash/values';
import Vue, { VNode } from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { DropdownButton } from '../DropdownButton/DropdownButton';
import { TextInput } from '../TextInput/TextInput';

require('./RelativeDateInput.scss');

@Component({ name: 'RelativeDateInput' })
class RelativeDateInput extends Vue {
  static readonly EVENT_CHANGE = 'change';
  static readonly EVENT_FOCUS_OUT = 'focusOut';

  @Prop({ type: Object, required: true })
  readonly value: RelativeDate;

  @Prop({ required: false, default: false })
  readonly disabled: boolean;

  @Prop({ type: Boolean, required: false, default: false })
  readonly loading: boolean;

  @Prop({ type: Boolean, required: false, default: false })
  readonly autoFocus: boolean;

  private inputValue: string = '';
  private inputError: string | null = null;

  @Watch('value', { immediate: true })
  onValueChange(): void {
    this.inputValue = String(this.value.offset);
  }

  private get selectedUnit(): DropdownOption<RelativeDate.TimeUnit> {
    return this.timeUnitOptions.find(({ value }) => value === this.value.unit)!;
  }

  private get timeUnitOptions(): Array<DropdownOption<RelativeDate.TimeUnit>> {
    return values(RelativeDate.TimeUnit).map((value: RelativeDate.TimeUnit) => ({
      value,
      label: RelativeDate.formatUnit(this.value.offset, value)
    }));
  }

  render(): VNode {
    return (
      <div class="lp-relative-time-input">
        <TextInput
          placeholder="value"
          autoFocus={this.autoFocus}
          disabled={this.disabled}
          value={this.inputValue}
          loading={this.loading}
          showTooltipWhenOverflowing={true}
          error={this.inputError}
          onInput={this.onUnitInput}
          onFocusOut={this.emitFocusOut}
        />
        <DropdownButton
          disabled={this.disabled}
          activeItem={this.selectedUnit}
          items={this.timeUnitOptions}
          inline={true}
          onSelect={this.onSelectTimeMode}
        />
        <div class="lp-relative-time-input-direction">Ago</div>
      </div>
    );
  }

  private onUnitInput(value: string): void {
    this.inputValue = value;

    const offset = Math.floor(Number(value));

    if (isNaN(offset) || offset <= 0 || offset > Number.MAX_SAFE_INTEGER) {
      this.inputError = `Value must be a number`;

      return;
    }

    this.inputError = null;
    this.emitChange({ offset });
  }

  private onSelectTimeMode({ value }: DropdownOption<RelativeDate.TimeUnit>): void {
    this.emitChange({ unit: value });
  }

  private emitChange(value: Partial<RelativeDate>): void {
    if (this.inputError) {
      return;
    }

    const newValue: RelativeDate = { ...this.value, ...value };

    this.$emit(RelativeDateInput.EVENT_CHANGE, newValue);
  }

  private emitFocusOut(): void {
    this.$emit(RelativeDateInput.EVENT_FOCUS_OUT);
  }
}

export { RelativeDateInput };
